'use es6';

export var getProviderNames = function getProviderNames(state) {
  return state.providers.names;
};
export var getProvidersRequestStatus = function getProvidersRequestStatus(state) {
  return state.providers.requestStatus;
};